module.exports = __webpack_public_path__ + "img/stores_appointment@2x.38913f2.jpg";